import { getEscapedRoles } from '@/utils/i18n-escape'

export default {
  title: '最佳案例',
  roles: getEscapedRoles([
    {
      name: '市场',
      objectives: [
        {
          content: '保持XX游戏品牌领先优势，提升市场知名度与影响力',
          keyResults: [
            '品牌策略：重新定义XX游戏品牌，差异化表达品牌理念，以专项形式落地品牌策略，产出10款宣传素材，总曝光量达到1亿',
            '宣传片：首月完成1支混剪出街视频，Q3周期结束前完成XX新游戏品牌的视频拍摄',
            '渠道合作：共创顶级IP合作，吸引10个XX站粉丝量在100万以上的品牌账号入驻'
          ]
        },
        {
          content: '沉淀创意经验和品牌管理方法论，输出中台支持能力',
          keyResults: [
            '完成素材中心系统的搭建，Q3周期内形成至少1,000份创意素材',
            '形成一套高质量的素材撰写方法论，提升整体员工撰写素材的效率和质量，至少缩短素材撰写周期30%'
          ]
        },
        {
          content: '通过在新社交媒体上的线上引流活动，提升活跃粉丝玩家数量',
          keyResults: [
            '每周至少撰写10篇高质量推文，单篇阅读量不低于10万，周期内新增粉丝玩家数5万@王一@Lisa',
            '至少开展10场线上转发有奖活动，单场平均转发量不低于1万，参与活动的粉丝玩家占比不低于30%@王一',
            '进行推文数据分析，并根据结果调整写作方式，下半月阅读量均值比上半月提升10%@王一'
          ]
        }
      ]
    },
    {
      name: '产品',
      objectives: [
        {
          content: '进军XX赛道，完成初代产品设计',
          keyResults: [
            '通过调研玩家圈层，提炼玩家核心需求，输出相关统计结果',
            '根据调研结果，确定产品XX研发方向，并输出产品方案，并获得评审会认可',
            '进行灰度测试并优化产品，在周期内提升测试用户满意度至90%@Lisa@Lily@王一'
          ]
        },
        {
          content: '完成产品基础能力优化，提升玩家满意度',
          keyResults: [
            '调整XX体系，优化XX能力，用户满意度从80%提升至90%@Lily',
            '引入XX系统，强化产品XX能力，打通与业务团队XX的数据@王一',
            '完成产品需求的排期，明确当前所有需求的实现顺序，保证P0需求如期完成'
          ]
        },
        {
          content: '优化XX产品的重点功能和体验，充分满足商业化要求',
          keyResults: [
            'X月X日前完成XX功能，满足XX应用商店上架标准@Lisa',
            '在本次OKR周期前，打通Y产品的账户，支持免注册登录，免注册用户占比达到20%@王一',
            '上架1个月内完成2个关键功能的A/B测试，提升平均页面留存率至20%@Lisa@Lily'
          ]
        }
      ]
    },
    {
      name: '研发',
      objectives: [
        {
          content: '为XX业务提供高效稳定的系统支持',
          keyResults: [
            '优化XX算法，缩短系统对客户需求的相应时间至0.1秒，同时维持Bug率不变 @王一',
            'XX方案平稳落地，Bug率控制在3%之内，系统无重大事故@王一 @Lily',
            '新建XX评估方案与XX模型，实现系统稳定性的可量化统计分析'
          ]
        },
        {
          content: '打造完善的企业数据中台，实现所有产品数据的可积累、可溯源',
          keyResults: [
            '完后数据中台框架设计与方案设计，获得高管层、业务端一致通过 @Lily',
            '完成数据中台初代版本的模型搭建，稳定性保持在99.9%以上，无重大事故 @王一 @王二',
            '初代版本达成后实现主营业务各环节数据100%可溯源、可统计'
          ]
        },
        {
          content: '为即将开始的XX业务储备好充分的研发人才',
          keyResults: [
            '招聘测试工程师10人(满足XX要求)，提升团队XX能力',
            '从一线大厂招聘有相似业务经历的技术人才1人，带来成熟的业务经验',
            '新业务组全员进行XX课程培训并全部通过测试（80分），确保XX能力达标@Lisa@Lily'
          ]
        }
      ]
    },
    {
      name: '财务',
      objectives: [
        {
          content: '建立规范的预算管理体系，提升预算监控能力',
          keyResults: [
            '完成公司整体预算项目的梳理，明确预算项目和核算项目之间的映射关系，搭建一套完整、清晰的预实对比和分析体系（例如：明确分析周期、维度等）@小李子',
            'KR2 新版财务日报上线，展示科目和维度需进一步细化（依据XX会议商定标准），数据更新周期缩短至T+8小时',
            '预算监控功能上线，各部门覆盖率达到100%，月均预警次数不低于6次@Lily'
          ]
        },
        {
          content: '搭建财务共享服务中心，实现财务团队的降本、增效、转型',
          keyResults: [
            '引入咨询公司和技术公司，设计财务共享服务方案与平台，方案中要明确节省的人员成本和运转效率的提升程度@Lily@tom',
            '落地财务共享服务方案，完成财务人员的集中管理，至少覆盖集团下属80%以上的子公司',
            '完成SSC人员的职能专业化分工，效率提升比例不低于50%（总工时统计），以及本地财务人员的释放和业务转型，释放和转型比例不低于35%'
          ]
        }
      ]
    }
  ])
}
